import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DialogRef } from '../../dialog/dialog-ref';
import { DialogConfig } from '../../dialog/dialog-config';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ModelCacheService } from 'src/modules/base/services/model-cache.service';


@Component({
    selector: 'app-auto-click-component',
    templateUrl: './auto-click-component.component.html',
    styleUrls: ['./auto-click-component.component.scss'],
    standalone: false
})
export class AutoClickComponentComponent implements OnInit, AfterViewInit {
  photoClicked: boolean = true;
  faceImgCapture: boolean = false;
  image_data_url: any;
  _webcamList: any;
  showCameraPopUp: boolean = false;
  device: any;
  resourceName: String = "Click Photos"
  NSEC: number = 2;
  detectionThreshold: number = this.NSEC * 1000;
  retryCount = 3;
  model!: any;
  modelLoaded: boolean = false;
  faces: any[] = [];
  detectionActive: boolean = false;
  private selectedSearch = { key: "uhId", label: "field.label.UHID" };

  constructor(
    private modal: DialogRef,
    private util: UtilService,
    private alert: AlertsService,
    private dialog: DialogRef,
    private appService: AppService,
    private dialogConfig: DialogConfig,
    private l: LoaderService,
    private baseService: BaseService,
    private modelCacheService: ModelCacheService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.getlistofCameras()
    if (this.dialogConfig != undefined && this.dialogConfig.data != undefined && this.dialogConfig.data.send_base64_data != undefined && this.dialogConfig.data.send_base64_data) {
      this.faceImgCapture = true;
    }
  }

  async initializeFaceDetection() {
    try {
      this.alert.info('Loading face detection model...');
      this.model = await this.modelCacheService.loadBlazeFaceModel();
      this.modelLoaded = true;
      this.alert.success('Face detection model loaded successfully!');
      await this.startCamera();
    } catch (error) {
      console.error('Error during initialization:', error);
      this.alert.error('Failed to initialize face detection.');
    }
  }

  ngAfterViewInit() {
    this.l.showSpinner();
    this.util.detectWebcam(async (isCameraAvailable: boolean) => {
      if (isCameraAvailable) {
        this.checkCameraPermission(async (permissionStatus: any) => {
          if (permissionStatus === "prompt" || permissionStatus === "denied") {
            this.util.checkCameraAccessStatus();
            this.device = "camera";
            this.showCameraPopUp = true;
          } else {
            await this.initializeFaceDetection(); // Initiate the model and camera sequence
            this.l.hideSpinner();
          }
        });
      } else {
        this.alert.error("No camera detected");
      }
    });
  }

  getlistofCameras() {
    navigator.mediaDevices.enumerateDevices().then(getVideoInputs => {
      var mt_array = [];
      getVideoInputs.forEach(mediaDevice => {
        if (mediaDevice.kind === 'videoinput') {
          mt_array.push(mediaDevice);
        }
      });
      this._webcamList = mt_array;
    })
  }

  closedevicePopup(event: any) {
    this.closePopup()
  }

  async startCamera() {
    const video: any = document.querySelector("#video");
    const canvas: any = document.querySelector("#canvas");
    const ctx = canvas.getContext("2d", { antialias: false })!;

    try {
      // Request access to the camera
      const stream: MediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false,
      });
      video.srcObject = stream;

      video.addEventListener("loadedmetadata", () => {
        video.play();
        canvas.width = video.videoWidth * window.devicePixelRatio;
        canvas.height = video.videoHeight * window.devicePixelRatio;

        this.startFaceDetection(video, canvas, ctx);
      });

      video.addEventListener("error", (err) => {
        console.error("Error with the video stream:", err);
        this.alert.error("Unable to access the video stream.");
      });
    } catch (error) {
      console.error("Error starting the camera:", error);
      this.alert.error("Failed to start the camera.");
    }
  }

  startFaceDetection(video: HTMLVideoElement, canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, retryAttempt = 0) {
    this.detectionActive = true; // Activate the detection loop
    let faceDetectionTimeout: any = null;
  
    const detectFaces = async () => {
      if (!this.detectionActive) return; // Stop detection if the flag is false
  
      if (video.readyState === video.HAVE_ENOUGH_DATA && this.modelLoaded) {
        const faces = await this.model.estimateFaces(video, false);
        this.faces = faces;
  
        // If faces are detected, start a countdown
        if (this.faces.length > 0) {
          console.log("Faces detected:", faces);
  
          if (!faceDetectionTimeout && this.photoClicked) {
            console.log("Face detected. Starting countdown...");
            this.alert.info(`Hold still! Capturing in ${this.NSEC} seconds...`);
  
            // Start a 5-second countdown
            faceDetectionTimeout = setTimeout(() => {
              console.log("Countdown complete. Capturing photo...");
              this.detectionActive = false;
              faceDetectionTimeout = null; // Reset the timeout reference
              this.facePhoto(video, canvas, ctx, retryAttempt); // Capture photo
              this.faces = null;
            }, this.detectionThreshold);
          }
        } else {
          // If no faces are detected, reset the countdown
          if (faceDetectionTimeout) {
            console.log("Face lost. Resetting countdown...");
            clearTimeout(faceDetectionTimeout);
            faceDetectionTimeout = null;
          }
        }
  
        // Render video and bounding boxes on the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        if (this.photoClicked)
          faces.forEach((face: any) => {
            ctx.beginPath();
            ctx.strokeStyle = "blue";
            ctx.lineWidth = 2;
            ctx.rect(
              face.topLeft[0],
              face.topLeft[1],
              face.bottomRight[0] - face.topLeft[0],
              face.bottomRight[1] - face.topLeft[1]
            );
            ctx.stroke();
  
            ctx.fillStyle = "red";
            face.landmarks.forEach(([x, y]) => {
              ctx.fillRect(x, y, 5, 5)
            });
          });
      }
  
      requestAnimationFrame(detectFaces); // Continue the detection loop
    };
  
    detectFaces(); // Start the detection loop
  }
  

  facePhoto(video: HTMLVideoElement, canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, retryAttempt = 0) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  
    this.image_data_url = this.dataURItoBlob(canvas.toDataURL('image/jpeg'));
    this.photoClicked = false;
  
    console.log(this.image_data_url);
  
    this.baseService.action({ data: this.image_data_url }, "FACE_MATCH", "patient-registration", "face_match").subscribe(
      (response) => {
        if (response && response.errCode === 0) {
          console.log(response);
          let res = response.resource[0];
          this.modal.close({
            filterKey: res.uhId,
            selectedSearch: this.selectedSearch
          });
        } else {
          console.error(`Attempt ${retryAttempt + 1} failed:`, response.message);
  
          if (retryAttempt < this.retryCount - 1) {
            // Retry if the maximum retry count has not been reached
            console.log(`Retrying... (${retryAttempt + 1}/${this.retryCount})`);
            this.alert.info(`Retrying face match (${retryAttempt + 1}/${this.retryCount})...`);
            
            // Clear and reset the timeout before retrying
            this.photoClicked = true;
            this.detectionActive = true; // Restart detection loop
            this.startFaceDetection(video, canvas, ctx, retryAttempt + 1); // Restart face detection
          } else {
            // If retries are exhausted, close the modal with an error
            this.alert.error("Face match failed after multiple attempts.");
            this.modal.close({ filterKey: '', selectedSearch: this.selectedSearch });
          }
        }
      },
      (error) => {
        console.error("Error in face match:", error);
        if (retryAttempt < this.retryCount - 1) {
          console.log(`Retrying... (${retryAttempt + 1}/${this.retryCount})`);
          this.alert.info(`Retrying face match (${retryAttempt + 1}/${this.retryCount})...`);
          this.photoClicked = true;
          this.detectionActive = true;
          this.startFaceDetection(video, canvas, ctx, retryAttempt + 1); // Restart face detection
        } else {
          this.alert.error("Face match failed after multiple attempts.");
          this.modal.close({ filterKey: '', selectedSearch: this.selectedSearch });
        }
      }
    );
  }
  

  dataURItoBlob(dataURI) {
    var byteString;
    var byteString1;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]);
      byteString1 = dataURI.split(',')[1];
    } else {
      byteString = unescape(dataURI.split(',')[1]);
      byteString1 = dataURI.split(',')[1];
    }
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    if (this.dialogConfig != undefined && this.dialogConfig.data != undefined && this.dialogConfig.data.send_base64_data != undefined && this.dialogConfig.data.send_base64_data) {
      return byteString1;
    } else {
      return new Blob([ia], { type: mimeString });
    }

  }

  closePopup() {
    this.dialog.close();
  }

  ngOnDestroy() {
    this.detectionActive = false; // Stop the detection loop

    const video: any = document.querySelector("#video");
    if (video?.srcObject) {
      const stream = video.srcObject as MediaStream;
      stream.getTracks().forEach((track) => track.stop()); // Stop all video tracks
      video.srcObject = null; // Clear the video source
    }

    console.log("Component destroyed: Detection loop stopped and video stream closed.");
  }

  denyImage() {
    let canvas: any = document.querySelector("#canvas");
    let video: any = document.querySelector("#video");
    this.photoClicked = true;
    this.startCamera(); // Restart the camera stream
  }

  checkCameraPermission(callback) {
    var that = this;
    if (this.appService.checkNativeApp() || this.util.isiOS()) {
      callback(true);
    } else {
      const permissionName = "camera" as PermissionName;
      navigator.permissions.query({ name: permissionName }).then(function (permissionStatus) {
        if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
          that.alert.error("Please give permission to access Camera");
          callback(permissionStatus.state)
        } else {
          callback(permissionStatus.state);
        }
      })
    }
  }
}
